import { Form, Tabs } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { useActiveSection } from '../../../../queries/guides';
import { SectionLayout } from '../../../../types';
import { useSectionMutations } from '../../../../mutations/sections';
import {
  SECTION_COLUMN_GAP_LARGE,
  SECTION_COLUMN_GAP_MEDIUM,
  SECTION_COLUMN_GAP_NONE,
  SECTION_COLUMN_GAP_SMALL,
} from '../../../../constants/sections';
import { StyledInput } from '../../Styles';

export const SectionColumnGapEditor = () => {
  const { translate } = useTranslate();
  const { activeSection } = useActiveSection();
  const { editSectionColumnGap } = useSectionMutations();
  if (activeSection?.sectionLayout === SectionLayout.SINGLE) {
    return null;
  }

  const handleSpacingChange = (columnGap: number) => {
    editSectionColumnGap.mutate({ sectionId: activeSection?.id, columnGap });
  };

  return (
    <Form.Group aria-labelledby="label-1">
      <Form.Label id="label-1">
        {translate('SECTION_INSPECTOR.COLUMN_GAP')}
      </Form.Label>
      <Form.InputRow>
        <StyledInput
          isDisabled
          id="label-suffix"
          value={activeSection?.appearance?.columnSpacing.toString()}
          type="number"
          suffix="px"
          onChange={() => null}
        />
        <Tabs variant="clean">
          <Tabs.Tab
            label={translate('SECTION_INSPECTOR.SECTION_COLUMN_GAP_NONE')}
            isActive={
              activeSection?.appearance.columnSpacing ===
              SECTION_COLUMN_GAP_NONE
            }
            onClick={() => handleSpacingChange(SECTION_COLUMN_GAP_NONE)}
          />
          <Tabs.Tab
            label={translate('SECTION_INSPECTOR.SECTION_COLUMN_GAP_SMALL')}
            isActive={
              activeSection?.appearance.columnSpacing ===
              SECTION_COLUMN_GAP_SMALL
            }
            onClick={() => handleSpacingChange(SECTION_COLUMN_GAP_SMALL)}
          />
          <Tabs.Tab
            label={translate('SECTION_INSPECTOR.SECTION_COLUMN_GAP_MEDIUM')}
            isActive={
              activeSection?.appearance.columnSpacing ===
              SECTION_COLUMN_GAP_MEDIUM
            }
            onClick={() => handleSpacingChange(SECTION_COLUMN_GAP_MEDIUM)}
          />
          <Tabs.Tab
            label={translate('SECTION_INSPECTOR.SECTION_COLUMN_GAP_LARGE')}
            isActive={
              activeSection?.appearance.columnSpacing ===
              SECTION_COLUMN_GAP_LARGE
            }
            onClick={() => handleSpacingChange(SECTION_COLUMN_GAP_LARGE)}
          />
        </Tabs>
      </Form.InputRow>
    </Form.Group>
  );
};
